export const separerMilliers = (nb: number, locale = "fr-FR") => {
  if (typeof nb !== "number" || isNaN(nb)) {
    return String(nb);
  }

  return nb && !isNaN(nb) ? nb.toLocaleString(locale) : "-";
};

export const rangeOfNumber = (n: number): number[] => {
  return Array.from({ length: n }, (_, i) => i + 1);
};

export const formatThousands = (value: number | string): string => {
  if (value === null || value === undefined) return "";
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};
